import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { ChannelNotificationDetail } from '../modal';

export default function reducer(state: ChannelNotificationDetail = new ChannelNotificationDetail(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.CHANNEL_NOTIFICATION_DETAIL_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.CHANNEL_NOTIFICATION_DETAIL_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.CHANNEL_NOTIFICATION_DETAIL_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
